<template>
  <div>
    <header class="top-navbar">
      <div class="menu-toggle-wrap">
        <i class="menu-toggle icon-Close-bar" @click="$emit('ToggleMenu')" />
        <i class="menu-toggle icon-menu" @click="$emit('ToggleMenu')" />
      </div>
      <div class="top-navbar__title">
        <h3>
          <span v-if="admin == true">{{ $t("common.admin") }}</span>
          <span v-else-if="currentUser && admin == false">{{ currentUser.school_name }}</span>
          <!-- <span v-if="currentUser">{{ currentUser.school_name }}</span> -->
        </h3>
      </div>
      <div class="top-navbar__logout">
        <b-button @click.prevent="openDropDown()" class="dropdown-passage-year" :disabled="isEditRoute">
          <p>Année scolaires : {{ passageYears }}</p>
          <i class="ri-arrow-down-s-fill"></i>
          <div v-if="displayYears" class="dropdown">
            <a v-for="(ele, index) in schoolYearsData" :key="'school_year' + index" @click="handleSchoolYears(ele.id, ele.name, ele.status)" class="d-block"> {{ ele.name }} </a>
          </div>
        </b-button>

        <div class="top-navbar__notice">
          <span @click.prevent="openNoticeF()" v-if="currentUser">
            <span v-if="rdvs.length > 0" class="new-msg"></span>
            <img src="../../assets/icons/notice.svg" />
            <div v-if="openNotice" class="notice dropdown" :class="{'height-auto': rdvs.length === 0, 'height-auto-one': rdvs.length === 1}">
              <div class="notice__top">
                <div class="notice__top__left">
                  <span>{{ $t("rdv.notif") }}</span>
                </div>
              </div>
              <div class="not-rdf" v-if="rdvs.length === 0">
                <p>{{ $t("rdv.emptyNotif") }}</p>
              </div>
              <div class="notice__content" v-for="rdv in rdvs" :key="rdv.id">
                <div class="notice__content__img">
                  <span class="notice__content__img__notif"></span>
                  <img v-if="rdv.photo" class="img-avatar" :src="rdv.photo" />
                  <img v-else class="img-avatar" src="/images/avatar_student.png" />
                </div>
                <div class="notice__content__desc">
                  <div class="notice__content__desc__title">
                    <router-link class="simple-lien" :to="{name: 'listeRdv'}">
                      <h3>
                        {{ $t("rdv.bonjour") }}<br />
                        {{ $t("rdv.disc.msg1") }} <span> {{ rdv.first_name_parent }} {{ rdv.last_name_parent }} </span> {{ $t("rdv.disc.msg2") }}
                        <span> {{ rdv.first_name_student }} {{ rdv.last_name_student }}</span> {{ $t("rdv.disc.msg3") }}
                        <span> {{ rdv.first_name_teacher }} {{ rdv.last_name_teacher }} </span>
                      </h3>

                      <p>
                        {{ rdv.description }} <span>{{ formatDate(rdv.appointment_date_at) }} à {{ formatTime(rdv.appointment_time) }}</span>
                      </p>
                    </router-link>
                  </div>
                  <div class="notice__content__desc__action">
                    <button @click.prevent="refusRdv(rdv, this.acceptedRdv)" class="active router-link-exact-active btn button btn-primary">
                      {{ $t("rdv.btn.accepter") }}
                    </button>
                    <button @click.prevent="refusRdv(rdv, this.dendieRdv)" class="active router-link-exact-active btn button btn-second">
                      {{ $t("rdv.btn.refuse") }}
                    </button>
                    <button :to="{name: 'listeRdv'}" @click="pushData(rdv), (this.edit = true)" class="active router-link-exact-active btn button btn-second">
                      {{ $t("rdv.btn.modiferHeure") }}
                    </button>
                  </div>
                  <div class="notice__content__desc__date">
                    <p>{{ formatDateTime(rdv.created_at) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span v-else>__</span>
        </div>
        <div class="top-navbar__logout__name">
          <div class="icon-user">
            <img src="../../assets/icons/Icon-user.svg" />
          </div>
          <span @click.prevent="openMenu()" v-if="currentUser">
            <b>{{ currentUser.first_name }}</b>
            <i class="arrow down"></i>
            <div v-if="showDropdown" class="dropdown profil-user">
              <router-link v-if="currentUser" :to="{name: 'EditUser', params: {id: currentUser.id}}"> <i class="icon-edit-03"></i>{{ $t("button.editProfil") }} </router-link>
              <a @click="logOut" class>
                <i class="icon-deconnexion icon-log-out" />
                {{ $t("common.deconnect") }}
              </a>
            </div>
          </span>
          <span v-else>__</span>
        </div>

        <!-- <i class="icon-dots" @click="addStyle()" /> -->
      </div>
    </header>
    <div class="navbar-bottom__responsive container-fluid" ref="navbottom">
      <div class="col-lg-12 d-flex align-items-center">
        <div class="top-navbar__logout__name">
          <div class="icon-user">
            <img src="../../assets/icons/Icon-user.svg" />
          </div>
          <span v-if="currentUser">{{ currentUser.name }}</span>
        </div>
        <a class="top-navbar__logout__deconnexion" @click="logOut">
          <i class="icon-deconnexion icon-log-out" />
          <span>{{ $t("common.deconnect") }}</span>
        </a>
      </div>
    </div>
  </div>
  <!-- modal -->
  <div v-if="edit" class="modal-vue">
    <div class="overlay" @click="hideModal()"></div>
    <div class="modal-edition modal-rdv">
      <div class="titre-parent">
        <h3 class="title-modal">{{ $t("title.modifRdv") }}</h3>
        <button class="close" @click="hideModal()">
          <i class="icon-Add" />
        </button>
      </div>
      <div class="body-parent">
        <form @submit.prevent="updateRdv(rdv2)" novalidate autocomplete="off">
          <div class="spec-inputs">
            <div class="row">
              <div class="col-md-6">
                <div class="simple-input">
                  <div>
                    <input v-model="rdv2.parent" type="text" class="form-control" placeholder="Parent" :disabled="edit" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <div>
                    <input v-model="rdv2.enseignant" type="text" class="form-control" placeholder="Enseignant" :disabled="edit" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <div>
                    <Datepicker
                      v-model="rdv2.date"
                      class="custom-datepicker"
                      placeholder="Date"
                      :placeholder-class-name="customPlaceholderClass"
                      locale="fr"
                      autoApply
                      :enable-time-picker="false"
                      :format="format_date_v1"
                      :class="v$.rdv2.date.$error ? 'is-invalid' : ''"
                    />
                    <span v-if="v$.rdv2.date.$error" class="invalid-feedback">{{ v$.rdv2.date.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input select-wrapper">
                  <input
                    v-model="rdv2.selectedHour"
                    type="text"
                    class="form-control"
                    placeholder="Heure"
                    @input="validateHourFormat"
                    :class="v$.rdv2.selectedHour.$error ? 'is-invalid' : ''"
                  />
                  <span class="indice">Seuls le format HH:MM (10:00)</span>
                  <span class="invalid-feedback" v-if="showInvalidFormatError && !v$.rdv2.selectedHour.$error">Format heure invalide</span>
                  <span v-if="v$.rdv2.selectedHour.$error" class="invalid-feedback">{{ v$.rdv2.selectedHour.$errors[0].$message }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="simple-input">
                  <div>
                    <textarea v-model="rdv2.enseignant" type="text" class="form-control" placeholder="Sujet" :disabled="edit" />
                  </div>
                </div>
              </div>
              <div class="col-12 buttons bloc-btn">
                <div class="button-left">
                  <button type="button" class="btn btn-outline-primary button cancel" :disabled="loading" @click="hideModal()">
                    <i class="icon-Add custom-add" />
                    {{ $t("button.annuler") }}
                  </button>
                </div>
                <div class="button-right d-flex">
                  <button type="submit" class="btn button btn-primary" :disabled="loading || isConfirmed" @click="updateRdv(level)">
                    <i class="icon-Check" />
                    {{ $t("button.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "../../common/EventBus";
import RdvClass from "../../services/rdv.service";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "HeaderContent",
  ref: "headerContent",
  components: {
    Datepicker,
  },

  data() {
    return {
      token: null,
      acceptedRdv: 1,
      dendieRdv: 2,
      v$: useValidate(),
      showInvalidFormatError: false,
      admin: false,
      showDropdown: false,
      openNotice: false,
      edit: false,
      rdvs: [],
      params: {
        in_progress: true,
        sort: "created_at",
        order: false,
      },
      rdv2: {
        parent: null,
        enseignant: null,
        selectedHour: null,
        heure: null,
      },
      moment: null,
      displayYears: false,
      passageYears: "",
    };
  },
  validations() {
    return {
      rdv2: {
        date: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        selectedHour: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },

  computed: {
    ...mapGetters(["getSchoolYears"]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    schoolYearsData() {
      return this.getSchoolYears.map((ele) => ({...ele, name: ele.name.replace("/", "-")}));
    },

   isEditRoute() {
  const validRoutes = ["DetailStudent", "DetailTeacher", "DetailsClasse"];
  return validRoutes.includes(this.$route.name);
}
  },
  created() {

    this.moment = moment;
    this.token = localStorage.getItem("token");
    if(this.token){
        this.loadDataSchoolYears();
    }
  },
  mounted() {
    EventBus.on("call-list-function", this.ListRdv);

    this.ListRdv();
    EventBus.on("logOut", () => {
      this.logOut();
    });
    this.currentUser?.role?.map((role) => {
      if (role.name === "admin") {
        this.admin = true;
      } else if (role.name === "admin_school" || role.name === "parent") {
        this.admin = false;
      }
    });
  },
  deforeDestroy() {
    EventBus.remove("logout");
  },
  beforeUnmount() {
    //EventBus.off('call-list-function', this.ListRdv);
  },

  methods: {
    ...mapActions(["fetchSchoolYears"]),
    async loadDataSchoolYears() {
      await this.fetchSchoolYears();
      const findObj = this.schoolYearsData.find((ele) => ele.status === 1);
      if (findObj) {
        this.passageYears = findObj.name;
        this.$store.commit("SET_PASSAGE_YEARS", {id: findObj.id, status: findObj.status});
      }
    },
    openDropDown() {
      this.displayYears = !this.displayYears;
    },
    handleSchoolYears(id, name, status) {
      this.passageYears = name;
      this.$store.commit("SET_PASSAGE_YEARS", {id: id, status: status});
    },

    validateHourFormat() {
      const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // Regular expression to validate hour format
      this.showInvalidFormatError = !hourRegex.test(this.rdv2.selectedHour);
      this.showRequiredError = this.rdv2.selectedHour === "";
    },

    formatTime(timeString) {
      return moment(timeString, "HH:mm:ss").format("HH[h]mm");
    },

    formatDate(dateString) {
      moment.locale("fr"); // Set the locale to French
      return moment(dateString).format("dddd DD MMMM");
    },
    formatDateTime(dateTimeString) {
      const dateTime = moment(dateTimeString);

      if (dateTime.isSame(moment(), "day")) {
        return `Aujourd'hui ${dateTime.format("[à] H:mm")}`;
      } else if (dateTime.isSame(moment().subtract(1, "day"), "day")) {
        return `Hier ${dateTime.format("[à] H:mm")}`;
      } else {
        return dateTime.format("DD MMM [à] H:mm");
      }
    },

    openMenu() {
      this.showDropdown = !this.showDropdown;
    },
    openNoticeF() {
      this.openNotice = !this.openNotice;
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    addStyle() {
      this.$refs.navbottom.classList.toggle("toggleNavBottom");
    },
    refusRdv(rdv, type) {
      const formattedDate = moment(rdv.appointment_date_at).format("DD-MM-YYYY");
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });

      swalWithBootstrapButtons
        .fire({
          title: `Voulez-vous vraiment ${type === 1 ? "Accepter" : "Refuser"} le rendez-vous de ${rdv.first_name_teacher} ${rdv.last_name_teacher} ?`,
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              `Vous avez ${
                type === 1
                  ? `un RDV avec M. ${rdv.first_name_teacher} ${rdv.last_name_teacher} le ${formattedDate}`
                  : `Refuser un RDV avec M. ${rdv.first_name_teacher} ${rdv.last_name_teacher} le ${formattedDate}`
              }`,
              "",
              "success"
            );
            RdvClass.refus(rdv.id, type).then(
              () => {
                EventBus.dispatch("call-list-function2");

                this.ListRdv();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    hideModal() {
      this.edit = false;
    },

    pushData(rdv) {
      (this.rdv2.parent = rdv.first_name_parent),
        (this.rdv2.enseignant = rdv.first_name_teacher),
        (this.rdv2.date = rdv.appointment_date_at),
        (this.rdv2.selectedHour = rdv.appointment_time),
        (this.rdv2.id = rdv.id);
    },

    updateRdv(rdv2) {
      this.v$.$validate();
      if (!this.showInvalidFormatError && !this.v$.$error) {
        const data = {
          appointment_date_at: this.rdv2.date,
          appointment_time: this.rdv2.selectedHour,
        };

        RdvClass.update(this.rdv2.id, data)
          .then(() => {
            this.edit = false;
            this.ListRdv();
            const Swal2 = require("sweetalert2");

            Swal2.fire({
              title: "Vous-avez modifier le rendez-vous",
              icon: "warning",
              showCloseButton: true,
              showCancelButton: false,
              confirmButtonClass: "btn btn-confirm  btn-primary",
              confirmButtonText: this.$t("common.ok"),
              reverseButtons: true,
            }).then(() => {
              this.$router.push({name: "listeRdv"});
            });
            EventBus.dispatch("call-list-function2");

            this.ListRdv();
            this.is_created = true;
            this.loading = false;
          })
          .catch((error) => {
            this.is_created = false;
            this.loading = false;
          });
      }
    },
    ListRdv() {
      if (this.token) {
        this.loading = true;
        RdvClass.notice({
          params: {
            in_progress: true,
            sort: this.params.sort,
            order: this.params.order,
          },
        })
          .then((response) => {
            this.rdvs = response.data.data;
            this.loading = false;
          })
          .catch((error) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style>
.bloc-btn {
  display: flex;
  justify-content: flex-end;
}

.simple-input {
  margin-bottom: 15px;
}

textarea.form-control {
  height: 75px;
  padding: 0 15px;
  padding-top: 5px;
}

.cancel {
  margin-right: 15px;
}

.invalid-feedback {
  display: block;
}

.indice {
  margin: 0;
}
.simple-lien:hover {
  background-color: transparent !important;
}
.notice__content__desc__title p {
  font-weight: 400;
}
.cancel i.icon-Add.custom-add {
  transform: rotate(45deg);
}
</style>
